// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1lDx0","containerItemsCenter":"Skeleton_containerItemsCenter__1d1j_"};